import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeMerchandiserList = (data) => {
	return {
		type: Types.STORE_MERCHANDISER_LIST,
		payload: data
	};
};

export const fetchMerchandiserList =
	(params = '?userTypeList=MERCHANDISER&page=0&size=1000') =>
	async (dispatch) => {
		await ApiClient.GET('userSearch', params).then((response) => {
			dispatch(storeMerchandiserList(response.data.data));
		});
	};
